export default __webpack_public_path__ + "locales/fr/WebPlugins.json?hash=dcb3e127a8f8e076200c3f810c099532";